import {
  DashboardInfo,
  DashboardInfoProps,
} from '../DashboardInfo/DashboardInfo'
import { RadialBarDasboard } from '../RadialBarDashboard/RadialBarDashboard'
import { Container, Wrapper } from './CardDashboard.style'

type CardDashboardProps = DashboardInfoProps & {
  percentageGraphic?: number
  background: string
}

export function CardDashboard({
  percentageGraphic,
  children,
  total,
  percentage,
  background,
  colorTitle,
  color,
}: CardDashboardProps) {
  return (
    <Wrapper
      className={percentageGraphic ? '' : 'noGraphic'}
      background={background}
    >
      <Container>
        {percentageGraphic && (
          <div>
            <RadialBarDasboard percentageGraphic={percentageGraphic} />
          </div>
        )}
        <DashboardInfo
          total={total}
          percentage={percentage}
          colorTitle={colorTitle}
          color={color}
        >
          {children}
        </DashboardInfo>
      </Container>
    </Wrapper>
  )
}
